import { Helmet } from 'react-helmet';

import GlowingOrb from '../orb';
import metaLogo from '../../Assets/Images/Logo/Meta V3.png'
import saitSaLogo from '../../Assets/Images/Logo/Saitsa/Saitsa Clubs Logo - Primary - light.png'
const BlogPost = () => {
  return (
    <div className='relative z-10' style={{ padding: '40px', paddingLeft: '60px', paddingRight: '60px', alignSelf: 'center', fontSize: '14px' }}>
      <div className="header-block-one" style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', width: '100%' }}>
        <img src={metaLogo} width="auto" height="60px" alt="MetaLogo" />
        <img src={saitSaLogo} width="auto" height="25px" alt="SaitsaLogo" />
      </div>
      <Helmet>
        <title>Why Join META – SAIT’s Mechanical Engineering Technology Club</title>
        <meta
          name="description"
          content="Explore why META is the go-to student club for Mechanical Engineering students at SAIT. Discover events, mentorship, and industry opportunities."
        />
      </Helmet>
      <br /><br />
      <h1>
        Your Engineering Career Starts Here: Why META is Essential for SAIT Mechanical Engineering Students
      </h1>
      <br />
      <br />
      <p>
        The mechanical engineering industry doesn't just want graduates with technical knowledge. They want professionals who can lead projects, solve complex problems, and adapt to rapidly evolving technologies. If you're studying Mechanical Engineering Technology at SAIT, there's one organization specifically designed to bridge that gap between your classroom education and career success: META.
      </p>
      <br />
      <h2>What Makes META Different</h2>
      <br />
      <p>
        The Mechanical Engineering Technology Association isn't just another student club. We're your direct connection to Alberta's mechanical engineering industry, built by students who understand exactly what you're facing in your program and career preparation.
        While your courses teach you the fundamentals, META gives you something equally valuable: real-world context, professional relationships, and hands-on leadership experience that employers actively seek.
      </p>
      <br />
      <h2>The META Advantage: Beyond Textbooks</h2>

      <br />
      <p>Industry Access You Can't Get Elsewhere
        Our networking events connect you directly with hiring managers, senior engineers, and alumni who've successfully transitioned from SAIT to thriving careers. These aren't generic career fairs. They're targeted opportunities to build relationships with people who specifically value SAIT graduates.</p>
      <p>Mentorship That Actually Works
        Get paired with upper-year students and alumni who've walked your exact path. They understand SAIT's program structure, Alberta's job market, and can provide specific guidance on everything from course selection to interview preparation.</p>
      <p>Skills Employers Demand
        Through workshops, project collaborations, and leadership roles within META, you'll develop the soft skills that differentiate good engineers from great ones: communication, project management, and strategic thinking.</p>


      <br />
      <h2>META members consistently report:</h2>
      <br />
      <p>
        Higher internship placement rates
        More confident job interviews
        Stronger technical portfolios
        Valuable professional references

        Whether your interests lie in design innovation, manufacturing optimization, automation systems, or emerging technologies, META connects you with both peers and professionals in your specific area of focus.</p>
      <br />

      <h2>Your Network is Your Net Worth</h2>
      <br />
      <p>
        In Alberta's competitive engineering landscape, technical skills get you noticed, but professional relationships get you hired. META provides exclusive access to:

        Industry speaker panels featuring local engineering leaders
        Behind-the-scenes facility tours with major employers
        Early access to internship and job postings
        Direct introductions to recruiters and hiring managers
      </p>
      <br />
      <h2 >
        Ready to Level Up Your Engineering Career?
      </h2>
      <br />
      <p>
        Joining META means joining the future of mechanical engineering at SAIT. Be part of the club where your ideas matter, your network grows, and your experience deepens.
      </p>
      <br /><br />
      <div>
        <a 
        style={{ textDecoration: 'underline' }} 
        href="https://campus.hellorubric.com/?s=9135"
        target='_blank'
        rel='noreferrer'
        >
          <h2>Press here to join Today</h2></a><br/>

        <p><strong>Follow us on Instagram:</strong>
         <a 
         href="https://instagram.com/meta.sait"
          target="_blank" rel="noreferrer" 
          className="text-blue-600 underline"
         >
          @meta.sait</a>
         </p>
         <br />
        <p>
          <strong>Connect with us on linkedin:</strong>
           <a 
           href="https://www.linkedin.com/company/meta-sait" target="_blank" rel="noreferrer" className="text-blue-600 underline"
           >Mechanical Engineering Technology Association</a>
           </p>
           <br />

        <p>
          <strong>Contact us via email:</strong>{' '}
           <a
             href="mailto:meta.saitclub@outlook.com"
             className="text-blue-600 underline"
               >
             meta.saitclub@outlook.com
           </a>
        </p>
           <br />

        {/* <p>
        <strong>Visit our site:</strong>
         <a href="https://meta-sait.com" target="_blank" rel="noreferrer" className="text-blue-600 underline"
         >meta-sait.com</a>
         </p> */}

        <p>
          <strong>Get involved:</strong> 
          Open to all Mechanical Engineering Technology students!
          </p>
        <br /><br />
        <h4>Mikiyas Haile</h4>
        <h6>Vice President, META</h6>
        <h6><span>May 30, 2025</span></h6>
      </div>
      <GlowingOrb />
    </div>
  );
};

export default BlogPost;
